<template>
  <FilterBadge v-bind="{ ...$props, ...$attrs }" icon="fas fa-align-left">
    {{ filter.searchText }}
  </FilterBadge>
</template>

<script setup lang="ts">
import type { PropType } from "vue";
import DescriptionDraftFilter from "../../filterImplementations/DescriptionDraftFilter";
import FilterBadge from "./FilterBadge.vue";

defineProps({
  filter: {
    type: Object as PropType<DescriptionDraftFilter>,
    required: true,
  },
});
</script>
